<template>
  <div class="modal-mask" v-if="value" @click.self="close">
    <div class="modal-box" :class="{ show: value }">
      <button class="modal-close" @click="close">×</button>
      <div class="modal-title" v-if="title">{{ title }}</div>
      <div class="modal-body">
        <img v-if="imgUrl" :src="require('@/assets/' + imgUrl)"  class="modal-img" alt="图片" />
        <div v-else-if="html" v-html="html" class="modal-html"></div>
        <div v-else class="modal-text">{{ content }}</div>
      </div>
      <div class="modal-footer" v-if="showCancel || showConfirm">
        <button v-if="showCancel" class="btn cancel" @click="close">取消</button>
        <button v-if="showConfirm" class="btn confirm" @click="confirm">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: String,
    content: String,
    imgUrl: String,
    html: String,
    showCancel: { type: Boolean, default: true },
    showConfirm: { type: Boolean, default: false }
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    confirm() {
      this.$emit("input", false);
      this.$emit("confirm");
    }
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999 !important;
}

.modal-box {
  width: 90%;
  max-width: 500px;
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  position: relative;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.3s ease;
}

.modal-box.show {
  opacity: 1;
  transform: translateY(0);
}

.modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f2f2f2;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

.modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 16px;
  text-align: center;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  margin-bottom: 20px;
  text-align: center;
}

.modal-img {
  max-width: 100%;
  max-height: 300px;
  border-radius: 8px;
  object-fit: contain;
}

.modal-text {
  font-size: 16px;
  line-height: 1.6;
  color: #333;
}

.modal-footer {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn {
  padding: 10px 24px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

.cancel { background: #f2f2f2; color: #666; }
.confirm { background: #4f46e5; color: #fff; }
</style>